<template>
<div class="audioText-ui">
    <audio controls class="audio" autoplay id="audio">

        <source :src="audioUrl"  type="audio/mpeg">
    </audio>
    <div class="content" v-html="datas.content">

    </div>
</div>
</template>

<script>
// 标题
export default {
    data() {
        return {
            audioUrl: '',

        };
    },
    props: {
        datas: Object
    },
    computed: {
        style() {

        }

    },

    methods: {

    },
    mounted() {
        this.audioUrl = this.datas.mp3Url

    }
};
</script>

<style lang="less">
.audioText-ui {
    padding: 0 0.4rem;

    .audio {
        width: 100%;
        height: 0.8rem;
    }

    .content {
        img {
            max-width: 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/audioText.vue